import delay from 'delay'
// eslint-disable-next-line no-restricted-imports -- TODO: Fix this the next time the file is edited.
import lodash from 'lodash'
import ms from 'ms'

const { isEqual } = lodash

const createFilesystemMonitor = ({ filesystemStatsAtom, getFilesystemInfo, logger }) => {
  const start = async () => {
    if (!getFilesystemInfo) return

    while (true) {
      try {
        const [fsInfo, previousValue] = await Promise.all([
          getFilesystemInfo(),
          filesystemStatsAtom.get(),
        ])

        if (!isEqual(previousValue, fsInfo)) {
          await filesystemStatsAtom.set(fsInfo)
        }
      } catch (error) {
        logger.warn('failed to get filesystem stats', error)
      }

      await delay(ms('2m'))
    }
  }

  return { start }
}

const filesystemMonitorDefinition = {
  id: 'filesystemMonitor',
  type: 'monitor',
  factory: createFilesystemMonitor,
  dependencies: ['filesystemStatsAtom', 'getFilesystemInfo?', 'logger'],
  public: true,
}

export default filesystemMonitorDefinition
